import { render, staticRenderFns } from "./addWhiteAccount.vue?vue&type=template&id=22b39486&scoped=true&"
import script from "./addWhiteAccount.vue?vue&type=script&lang=js&"
export * from "./addWhiteAccount.vue?vue&type=script&lang=js&"
import style0 from "./addWhiteAccount.vue?vue&type=style&index=0&id=22b39486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b39486",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b39486')) {
      api.createRecord('22b39486', component.options)
    } else {
      api.reload('22b39486', component.options)
    }
    module.hot.accept("./addWhiteAccount.vue?vue&type=template&id=22b39486&scoped=true&", function () {
      api.rerender('22b39486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/anchorWhitelistAccount/component/addWhiteAccount.vue"
export default component.exports